import React, { Component } from "react";
import { UserContext } from "../../Context";
import firebase from "./../../utils/firebase";
import { TertiaryColor } from "../../utils/consts";

import CheckCircleIcon from "@atlaskit/icon/glyph/check-circle";
import TrashIcon from "@atlaskit/icon/glyph/trash";
import DropzoneComponent from "react-dropzone-component";
import Button from "@atlaskit/button";

import "./uploadDocument.css";
export default class UploadDocument extends Component {
  constructor(props) {
    super(props);

    this.state = {};
  }

  handleUpload = (file, uid, name) => {
    console.log(file);
    const ref = firebase.storage().ref();
    const storageRef = ref.child(`my`);
    const metadata = {
      contentType: file.type,
      uid: uid,
      name: file.name
    };
    const uploadTask = storageRef.child(`${uid}/${name}`).put(file, metadata);

    uploadTask.on(
      "state_changed",
      snapshot => {
        this.setState({
          [`${name}Upload}`]:
            (snapshot.bytesTransferred / snapshot.totalBytes) * 100
        });
      },
      error => {
        console.log(error);
        this.setState({
          [`${name}Upload`]: null,
          [`${name}ImageURL`]: null
        });
      },
      () => {
        uploadTask.snapshot.ref.getDownloadURL().then(downloadURL => {
          this.handleDataSave(downloadURL, uid, name)
            .then(() => {
              this.setState({
                [`${name}ImageURL`]: downloadURL
              });
            })
            .catch(err => {
              console.log(err);
              this.setState({
                [`${name}Upload`]: null,
                [`${name}ImageURL`]: null
              });
            });
        });
      }
    );
  };

  handleDataSave = (downloadURL, uid, name) =>
    firebase
      .firestore()
      .collection("my")
      .doc(uid)
      .update({
        [`${name}`]: downloadURL
      });

  handleDeletion = (uid, item) => {
    const ref = firebase.storage().ref();
    const storageRef = ref.child(`my`);
    const deleteRef = storageRef.child(`${uid}/${item}`);
    const deleteStoragePromise = deleteRef.delete();
    const deleteDbPromise = firebase
      .firestore()
      .collection("my")
      .doc(uid)
      .update({
        [`${item}`]: firebase.firestore.FieldValue.delete()
      });
    Promise.all([deleteStoragePromise, deleteDbPromise])
      .then(() => {
        console.log("successfully deleted");
      })
      .catch(error => {
        console.log(error);
      });
  };

  render() {
    return (
      <UserContext.Consumer>
        {userContext => {
          console.log(userContext);
          const user = userContext.user || {};
          const uid = user.uid || "";
          return (
            <div className="profile-docs__container">
              <label className="profile-docs__title">{this.props.title}</label>
              {this.state[`${this.props.name}Upload`] === 100 ||
              (userContext.my && userContext.my[this.props.name]) ? (
                <div
                  className="profile-docs__preview"
                  style={{
                    backgroundImage: `url(${userContext.my[this.props.name]})`
                  }}
                >
                  <span className="profile-docs__preview-title">
                    <CheckCircleIcon
                      primaryColor={TertiaryColor}
                      size="medium"
                    />
                    {""} {this.props.title}
                  </span>
                </div>
              ) : (
                <DropzoneComponent
                  className="profile-docs__dropzone"
                  config={{
                    iconFiletypes: [".jpg", ".png", ".pdf"],
                    showFiletypeIcon: true,
                    postUrl: "no-url"
                  }}
                  eventHandlers={{
                    addedfile: file =>
                      this.handleUpload(file, uid, this.props.name)
                  }}
                  djsConfig={{
                    autoProcessQueue: false,
                    uploadMultiple: false,
                    acceptedFiles: ["image/*", "application/pdf"],
                    maxFiles: 1
                  }}
                />
              )}
              {this.state[`${this.props.name}Upload`] === 100 ||
                (userContext.my &&
                  userContext.my[this.props.name] && (
                    <Button
                      className="profile-docs__delete"
                      onClick={() => {
                        this.handleDeletion(uid, this.props.name);
                      }}
                      iconBefore={
                        <TrashIcon primaryColor={TertiaryColor} size="medium" />
                      }
                    >
                      DELETE
                    </Button>
                  ))}
            </div>
          );
        }}
      </UserContext.Consumer>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/uploadDocument/UploadDocument.js